<template>
    <div
        class="release-all-pages"
        v-b-modal.release-all-pages-modal>
        <i class="fa fa-unlock fa-fw"></i>{{ $t('magazine.release_everything') }}

        <b-modal
            id="release-all-pages-modal"
            :title="$t('magazine.release_all_pages')"
            :ok-title="$t('magazine.release')"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            @ok="onOk()"
            modal-class="apprentice-default-modal">
            <p>{{ $t('magazine.are_you_sure_you_want_to_release_all_pages') }}</p>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-release-all-pages-component',
    props: ['magazineId'],
    data() {
        return {
            num_pages: 0,
        };
    },
    methods: {
        onOk() {
            const data = { release_all_pages: true };
            this.alert.saving();

            this.axios.post(this.routes.magazineReleaseAllPages(this.magazineId), data).then(
                (response) => {
                    this.alert.success();
                    location.reload();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.release-all-pages {
    i {
        width: 20px;
        margin-right: map-get($grid-gutter-spacing, 'eight');
        color: $primary;
    }
}
</style>
